export const ROUTE_AREA = Object.freeze({
  MARKETING: 'marketing',
  WORKSPACE: 'workspace',
  AUTH: 'auth',
})

export const ROUTE_AUTH = Object.freeze({
  PUBLIC: 'public',
  REQUIRED: 'required',
  GUEST_ONLY: 'guestOnly',
})

export const DEFAULT_ROUTE_POLICY = Object.freeze({
  area: ROUTE_AREA.WORKSPACE,
  auth: ROUTE_AUTH.REQUIRED,
})

export function getRoutePolicy(route = {}) {
  const records = Array.isArray(route.matched) && route.matched.length
    ? route.matched
    : [route]

  return records.reduce((policy, record) => ({
    area: record?.meta?.area || policy.area,
    auth: record?.meta?.auth || policy.auth,
  }), { ...DEFAULT_ROUTE_POLICY })
}

export function getRouteAuthRedirect(route, isLoggedIn) {
  const { auth } = getRoutePolicy(route)

  if (auth === ROUTE_AUTH.REQUIRED && !isLoggedIn) {
    return { path: '/' }
  }
  if (auth === ROUTE_AUTH.GUEST_ONLY && isLoggedIn) {
    return { path: '/workspace' }
  }
  return null
}

export function shouldRunWorkspaceServices(route, isLoggedIn) {
  return Boolean(isLoggedIn) && getRoutePolicy(route).area === ROUTE_AREA.WORKSPACE
}

export function withRoutePolicy(route, policy) {
  return {
    ...route,
    meta: {
      ...(route.meta || {}),
      ...policy,
    },
  }
}

export function marketingRoute(route) {
  return withRoutePolicy(route, {
    area: ROUTE_AREA.MARKETING,
    auth: ROUTE_AUTH.PUBLIC,
  })
}

export function authRoute(route) {
  return withRoutePolicy(route, {
    area: ROUTE_AREA.AUTH,
    auth: ROUTE_AUTH.GUEST_ONLY,
  })
}
